export const GET_ALL_BILLS_START = 'GET_ALL_BILLS_START';
export const GET_ALL_BILLS_SUCCESS = 'GET_ALL_BILLS_SUCCESS';
export const GET_ALL_BILLS_ERROR = 'GET_ALL_BILLS_ERROR';
